import React from 'react';
import { TimetableTimeSlotsFilters, AdminTimetableSlotsList, AdminTimetableSlotsListVariables } from '@api/graphql/types';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import DateUtils from '@root/utils/DateUtils';
import { Summary, increaseSummary, initial, TimeslotRowType, weightFormat } from './TimetableSlotsTable';
import { Loading } from '@components/Loading';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

interface Props {
    filters: TimetableTimeSlotsFilters;
}

interface State {
    summary: any;
    isLoading: boolean;
}

type PropType = Props & InjectedIntlProps;


class DailySummary extends React.Component<PropType, State> {

    public componentDidMount() {
        this.fetchData();
    }

    public componentDidUpdate(props: PropType) {
        if (this.props.filters !== props.filters) {
            this.fetchData();
        }
    }

    private fetchData() {
        this.setState({isLoading: true}, () => {
            const variables: AdminTimetableSlotsListVariables = {
                page: 1,
                count: 1000,
                filters: {
                    id: this.props.filters.id ? this.props.filters.id : undefined,
                    status: this.props.filters.status ? this.props.filters.status : undefined,
                    range_date: this.props.filters.range_date ? DateUtils.formatDate(this.props.filters.range_date) : undefined,
                },
            };
            GraphQLClient.query<AdminTimetableSlotsList>({
                query: Queries.timetableSlots,
                variables,
            }).then(response => {
                const data = response.data.adminTimetableTimeSlots ? response.data.adminTimetableTimeSlots.data.map((item) => {
                    return {...item, timeRangeId: item.timeRange.id, timeRange: `${item.timeRange.time_from}-${item.timeRange.time_to}`, linked_orders: item.orders ?
                        item.orders.filter((order) => (order.parent_order)).length : 0};
                }) : [];
                const summary: Summary = (data as TimeslotRowType[]).reduce(increaseSummary, {forenoon: initial, afternoon: initial});

                this.setState({summary, isLoading: false});
            });
        });
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.timetable.${id}` });
    }

    public render() {
        if (!this.state || this.state.isLoading) {
            return <Loading />;
        }

        const data = this.state.summary;

        return (
            <div className="">
                <hr />
                <h3>{this.label('dailySummary')} - {this.props.filters.range_date.toString() || ''} - {this.props.filters.status || this.label('status.all')}</h3>
                <table className="table" style={{marginTop: '30px'}}>
                    <thead>
                        <tr>
                            <th />
                            <th>{this.label('order_limit.title')}</th>
                            <th>{this.label('reserved_order_count.title')}</th>
                            <th>{this.label('linked_orders.title')}</th>
                            <th>{this.label('weight_limit.title')}</th>
                            <th>{this.label('reserved_weight_count.title')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{this.label('forenoon')}</td>
                            <td>{data.forenoon.order_limit}</td>
                            <td>{data.forenoon.reserved_order_count}</td>
                            <td>{data.forenoon.linked_orders}</td>
                            <td>{weightFormat(data.forenoon.weight_limit)}</td>
                            <td>{weightFormat(data.forenoon.reserved_weight_count)}</td>
                        </tr>
                        <tr>
                            <td>{this.label('afternoon')}</td>
                            <td>{data.afternoon.order_limit}</td>
                            <td>{data.afternoon.reserved_order_count}</td>
                            <td>{data.afternoon.linked_orders}</td>
                            <td>{weightFormat(data.afternoon.weight_limit)}</td>
                            <td>{weightFormat(data.afternoon.reserved_weight_count)}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        );
    }
}

export default compose(
    injectIntl,
)(DailySummary);



// WEBPACK FOOTER //
// ./src/modules/Timetable/components/DailySummary.tsx